import { useMutation, useQueryClient } from '@tanstack/react-query';
import { http } from '@/lib/http';
import type { CaseOverviewSummary } from './use-case-overview';

// Mutation for the "Resolve case" admin action per docs/ui/operator-ui-tds.md
// §8 use case `i1`. POSTs to the BFF; on success, optimistically marks the
// case RESOLVED in the overview cache so the status badge updates within 1s
// per the NEX-159 acceptance criterion (the StateChanged event from the BFF
// will overwrite with the authoritative shape shortly after).

export function useResolveCase(caseUrn: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      await http.post(`v1/cases/${encodeURIComponent(caseUrn)}/resolve`);
    },
    onSuccess: () => {
      qc.setQueryData<CaseOverviewSummary>(['cases', caseUrn, 'overview'], (prev) => ({
        ...(prev ?? { caseUrn }),
        status: 'RESOLVED',
        sagaState: 'Resolved',
      }));
    },
  });
}
